import React from 'react';
import { LucideIcon } from 'lucide-react';

export interface FeatureCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  iconColor?: 'orange' | 'blue' | 'green' | 'purple';
  className?: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  icon: Icon,
  iconColor = 'orange',
  className = ''
}) => {
  const iconColorClasses = {
    orange: 'bg-orange-100 text-orange-500',
    blue: 'bg-blue-100 text-blue-500',
    green: 'bg-green-100 text-green-500',
    purple: 'bg-purple-100 text-purple-500'
  };

  return (
    <div className={`bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300 text-center group ${className}`}>
      <div className={`w-16 h-16 ${iconColorClasses[iconColor]} rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
        <Icon className="w-8 h-8" />
      </div>
      <h3 className="text-2xl font-semibold text-gray-900 mb-4">
        {title}
      </h3>
      <p className="text-gray-600 leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default FeatureCard;
